function insertLikeButton(parameters, target) {

    var shareButton = {
        target: target,
        title: parameters.shareButtonTitle,
        description: parameters.shareButtonDescription,
        image: parameters.jsRoot + 'aol_share_' + parameters.lang + '.jpg'
    };

    if (parameters.shareButtonImage) {
        shareButton.image = parameters.shareButtonImage;
    }

    if (parameters.shareButtonUrl) {
        shareButton.url = parameters.shareButtonUrl;
    }

    if (parameters.shareButtonStyle) {
        shareButton.style = parameters.shareButtonStyle;
    }

    Social.instance.insertLikeButton(shareButton);
}